export const accountDrgColumns = [
  'claim_is_newer',
  'r1_id',
  'account_number',
  'drg_type',
  'drg_version',
  'apr_drg',
  'severity_of_illness',
  'ms_drg',
  'claim_ms_drg',
  'claim_apr_drg',
  'claim_severity_of_illness',
  'claim_type_of_bill',
  'claim_drg_code',
];
